import React, { useContext, useEffect } from "react";
import { CartContext } from "../../contexts/CartContext";
import { Field } from "formik";
import { ReactComponent as VanIcon } from "../../icons/vanIcon.svg";
import { ReactComponent as ParcelIcon } from "../../icons/parcelIcon.svg";
// import PickupLocation from "./PickupLocation"; // Update the path to your component
// import { ContactInfo } from "./ContactInfo"; // Update the path to your component
import { getTaxRate } from "../../utils/taxRate"; // Update the path to your helper function

const DeliverySection = ({ state, values }) => {
  const { setTaxRate, setShippingCost } = useContext(CartContext);

  useEffect(() => {
    const taxRate = getTaxRate(state);
    console.log("Tax rate: ", taxRate); // "Tax rate: 0.07
    setTaxRate(taxRate);
  }, [state, setTaxRate]);

  useEffect(() => {
    if (values.delivery === "free") {
      values.delivery = "free";
      setShippingCost(0);
    } else if (values.delivery === "pick") {
      values.delivery = "pick";
      setShippingCost(0);
    } else if (values.delivery === "usps") {
      values.delivery = "usps";
      setShippingCost(10.85);
    } else if (values.delivery === "priority") {
      values.delivery = "priority";
      setShippingCost(49.45);
    }
  }, [values, setShippingCost]);

  return (
    <div>
      <div className="block text-xl font-medium text-black mb-3">Delivery</div>
      <div role="group" className="flex flex-col">
        <label
          className={`gap-2 text-sm text-black w-full h-14 border rounded-t-md flex items-center px-3 sm:px-6 cursor-pointer ${
            values.delivery === "free"
              ? "bg-lightStealBlue border-black"
              : "border-pearlGray border-b-0"
          }`}
        >
          <div className="relative">
            <Field
              className="_6hzjvo4"
              type="radio"
              name="delivery"
              value="free"
              checked
            />
          </div>
          <div className="flex justify-between items-center w-full">
            <span>FREE up to 15-days</span>
            <div className="w-4 h-4">
              <VanIcon />
            </div>
          </div>
        </label>

        <label
          className={`gap-2 text-sm text-black w-full h-14 border flex items-center px-3 sm:px-6 cursor-pointer ${
            values.delivery === "usps"
              ? "bg-lightStealBlue border-black"
              : "border-pearlGray border-b-0"
          }`}
        >
          <div className="relative">
            <Field
              className="_6hzjvo4"
              type="radio"
              name="delivery"
              value="usps"
            />
          </div>
          <div className="flex justify-between items-center w-full">
            <span>USPS Retail Ground 7-days</span>
            <span>$10.85</span>
            <div className="w-4 h-4">
              <VanIcon />
            </div>
          </div>
        </label>

        <label
          className={`gap-2 text-sm text-black w-full h-14 border flex items-center px-3 sm:px-6 cursor-pointer ${
            values.delivery === "priority"
              ? "bg-lightStealBlue border-black"
              : "border-pearlGray border-b-0"
          }`}
        >
          <div className="relative">
            <Field
              className="_6hzjvo4"
              type="radio"
              name="delivery"
              value="priority"
            />
          </div>
          <div className="flex justify-between items-center w-full">
            <span>Priority Mail Express 1-Day</span>
            <span>$49.45</span>
            <div className="w-4 h-4">
              <VanIcon />
            </div>
          </div>
        </label>

        <label
          className={`gap-2 text-sm text-black w-full h-14 border rounded-b-md flex items-center px-3 sm:px-6 cursor-pointer ${
            values.delivery === "pick"
              ? "bg-lightStealBlue border-black"
              : "border-pearlGray"
          }`}
        >
          <div className="relative">
            <Field
              className="_6hzjvo4"
              type="radio"
              name="delivery"
              value="pick"
            />
          </div>
          <div className="flex justify-between items-center w-full">
            <span>Pick up</span>
            <div className="w-4 h-4">
              <ParcelIcon />
            </div>
          </div>
        </label>
      </div>

      <div>
        {/* {values.delivery === "pick" ? (
          <div className="my-10">
            <PickupLocation values={values} />
          </div>
        ) : (
          <div className="mt-10">
            <ContactInfo values={values} />
          </div>
        )} */}

        <div className="mb-6 mt-2 text-sm text-black">
          <label className="cursor-pointer flex gap-2 items-center">
            <Field
              type="checkbox"
              name="allowMsgMarketing"
              className="h-4 w-4 rounded-lg checkbox-style"
            />
            Text me with news and offers
          </label>
        </div>
      </div>
    </div>
  );
};

export default DeliverySection;
